module.exports = __webpack_public_path__ + "static/event88-b7bf8750f2d8fd9c404be6ce45c31fc1.jpeg";